import { render } from "./ArtWorks.vue?vue&type=template&id=1fb6e3b6&scoped=true"
import script from "./ArtWorks.vue?vue&type=script&lang=js"
export * from "./ArtWorks.vue?vue&type=script&lang=js"

import "./ArtWorks.vue?vue&type=style&index=0&id=1fb6e3b6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fb6e3b6"]])

export default __exports__